module.exports = __webpack_public_path__ + "img/remote-control.b8d58c64.png";